import {User} from "@irati/types"
import {InjectIntl} from "@irati/utils/lang"

const usersListToString = (users: User[], formatMessage: InjectIntl["formatMessage"], limit = 2) => {
  const firstUser = `${users[0].firstName} ${users[0].lastName}`
  if (users.length === 1) {
    return firstUser
  }
  if (users.length > limit) {
    return formatMessage(
      {id: "recognition.recipients.list.others"},
      {
        firstUser,
        num: users.length - 1
      }
    )
  }
  const secondUser = `${users[1].firstName} ${users[1].lastName}`
  return formatMessage(
    {id: "recognition.recipients.list.two"},
    {
      firstUser,
      secondUser
    }
  )
}

export default usersListToString
